import { render, staticRenderFns } from "./ObraDetalle.vue?vue&type=template&id=43fd4d98&"
import script from "./ObraDetalle.vue?vue&type=script&lang=js&"
export * from "./ObraDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports